/**
 * GraphQL errors raised from a service ValidationError/ForbiddenError/NotFoundError
 * carry a code saying the message was written for an operator to read ("Items in a
 * quarantine zone can only be picked on a return sales order."). Anything else is a
 * runtime failure whose message would only confuse a picker, so it keeps the generic
 * fallback. The server sends the code but withholds the rest of the extensions bag
 * outside development.
 */
const OPERATOR_FACING_CODES = ['BAD_USER_INPUT', 'FORBIDDEN', 'NOT_FOUND'];

export function operatorFacingMessage(error, fallback) {
  const match = (error?.graphQLErrors || []).find(
    (graphQLError) =>
      OPERATOR_FACING_CODES.includes(graphQLError?.extensions?.code) &&
      !!graphQLError?.message
  );
  return match?.message || fallback;
}
